import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

@Injectable({
	providedIn: 'root'
})
export class MandatoryPasswordChangeGuard implements CanActivateChild {
	constructor(private router: Router) {}

	canActivateChild(
		_childRoute: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): boolean | UrlTree {
		// Bypassed mandatory password change check
		// const hasUserSession = Boolean(localStorage.getItem('userId'));
		// const mustChangePassword = localStorage.getItem('mustChangePassword') === 'true';
		// const isImpersonating = localStorage.getItem('isImpersonating') === 'true';
		// const isChangePasswordRoute = state.url.split('?')[0] === '/change-password';

		// if (!hasUserSession || !mustChangePassword || isImpersonating || isChangePasswordRoute) {
		// 	return true;
		// }

		// return this.router.createUrlTree(['/change-password'], {
		// 	queryParams: { required: true }
		// });
		return true;
	}
}
